import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserDataService } from '../../../../../../../../../src/app/DataServices/user-data.service';
import { AdditionalWorkDemandList } from '../../../../../business-entities/appointment-demand-list-view-model';
import { AdditionalWorkJobList } from '../../../../../business-entities/appointment-Job-list-view-model';
import { AdditionalWorkJobDetailsList } from '../../../../../business-entities/appointment-JobDetail-list-view-model';
import { AdditionalWorkDetailModel, AdditionalWorkDetails, AdditionalWorkJobDetailModel } from '../../../../../business-entities/appointment-service-details-view-model';
import { AppointmentWorkOrderService } from '../../../../../business-services/appointment-work-order.service';
import { AppointmentService } from '../../../../../business-services/appointment.service';
import { EditAppointmentService } from '../../../../../business-services/edit-appointment.service';
import { SettingService } from '../../../../../business-services/setting.service';
import { SendNotificationComponent } from '../../send-notification/send-notification.component';
@Component({
  selector: 'app-wo-confirmation',
  templateUrl: './wo-confirmation.component.html'
})
export class WOConfirmationComponent implements OnInit {
  currency: string;
  userRole: number;
  isReception: boolean;
  isAdmin: boolean;
  IsApproval: boolean;
  isCanBeDoneNow: boolean = false;
  isApprove: boolean = false;
  isReject: boolean = false;
  additionalWorkDetails: AdditionalWorkDetails;
  additionalWorkDetailsModel: Array<AdditionalWorkDetailModel> = [];
  additionalWorkJobDetailsViewModelList: Array<AdditionalWorkJobDetailModel> = []
  additionalWorkJobDetailsViewModel: AdditionalWorkJobDetailModel = {
    canBeDoneNow: false,
    description: '',
    fixedPrice: 0,
    isAdminApproved: 0,
    isCDSSApproved: 0,
    isCustomerApporved: 0,
    isMechanicApproved: 0,
    jobNo: 0,
    partInStock: 0,
    partNumber: '',
    price: 0,
    time: 0,
    quantity: 0,
    id: 0,
    isJob: false
  }
  additionalWorkDetailsViewModelList: Array<AdditionalWorkDetailModel> = []
  additionalWorkDetailsViewModel: AdditionalWorkDetailModel = {
    canBeDoneNow: false,
    description: '',
    fixedPrice: 0,
    isAdminApproved: 0,
    isCDSSApproved: 0,
    isCustomerApporved: 0,
    isMechanicApproved: 0,
    jobNo: 0,
    partInStock: 0,
    partNumber: '',
    price: 0,
    time: 0,
    demand: 0,
    id: 0,
    jobDetails: []
  }
  additionalWorkOrderDemand: AdditionalWorkJobDetailsList = {
    id: 0,
    appointmentId: 0,
    appointmentJobId: 0,
    demandNo: 0,
    jobId: 0,
    serviceId: 0,
    salesPart: '',
    costType: '',
    description: '',
    plannedQuantity: 0,
    salesPriceAmountVAT: 0,
    fixedPrice: 0,
    quantity: 0,
    canBeDoneNow: false,
    isCustomerApporved: 0,
    isMechanicApproved: 0,
    isAdminApproved: 0,
    isCDSSApproved: 0,
  }
  additionalWorkOrderJod: AdditionalWorkJobList = {
    id: 0,
    appointmentDemandId: 0,
    demandNo: 0,
    jobId: 0,
    description: '',
    price: 0,
    fixedPrice: 0,
    totalTime: 0,
    canBeDoneNow: false,
    isCustomerApporved: 0,
    isMechanicApproved: 0,
    isAdminApproved: 0,
    isCDSSApproved: 0,
    isEnable: false
  }
  additionalWorkOrderJobDetails: AdditionalWorkDemandList = {
    id: 0,
    demandNo: 0,
    shortDescription: '',
    customerRequirement: '',
    sumPerService: 0,
    fixedPrice: 0,
    sumPerServiceInclTax: 0,
    canBeDoneNow: false,
    isCustomerApporved: 0,
    isMechanicApproved: 0,
    isAdminApproved: 0,
    isCDSSApproved: 0,
    isEnable: false,
  };
  customerList:any = [];
  customerRadio:number = -1;
  customerMobileNumber:any = null;
  customerMobileCode:any = null;
  @ViewChild('customerListContent') customerListContent: TemplateRef<any>;
  @ViewChild('updateDemandConfirmContent') updateDemandConfirmContent: TemplateRef<any>;

  constructor(private model: NgbModal,
    public editAppointmentService: EditAppointmentService,
    public settingService: SettingService,
    // public workOrderService: AppointmentWorkOrderService,
    public workOrderAdditionalService: AppointmentWorkOrderService,
    private cookieservice: CookieService,
    private spinner: NgxSpinnerService,
    private appointmentService: AppointmentService,
    private userService: UserDataService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private readonly activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.additionalWorkDetailsModel = []
    this.userRole = this.userService.currentUserValue.roleType;
    this.isReception = this.userRole === fromEnums.UserRoles.Reception;
    this.isAdmin = this.userRole === fromEnums.UserRoles.SuperAdmin;
    this.currency = this.settingService.currencySymbol;
    this.GetAdditionalWorkDetails();
  }
  async GetAdditionalWorkDetails() {
    this.spinner.show()
    await this.appointmentService.GetAdditionalWorkDetails(this.editAppointmentService.appointmentDetails.id).then(data => {
      if (data.responseObject.errorCount > 0) {
        this.additionalWorkDetails = {
          appointmentAdditionalDemandList: [],
          appointmentAdditionalJobDetailList: [],
          appointmentAdditionalJobList: []
        }
      }
      else {
        this.additionalWorkDetails = data.responseObject;
        this.workOrderAdditionalService.additionalDemandList = this.additionalWorkDetails.appointmentAdditionalDemandList;
        this.workOrderAdditionalService.additionalJobList = this.additionalWorkDetails.appointmentAdditionalJobList;
        this.workOrderAdditionalService.additionalJobDetailsList = this.additionalWorkDetails.appointmentAdditionalJobDetailList;
        this.mapAdditionalWorkDetails()
      }

    })
    this.spinner.hide()
  }
  onRefresh() {
    this.workOrderAdditionalService.additionalDemandList = []
    this.workOrderAdditionalService.additionalJobList = [];
    this.workOrderAdditionalService.additionalJobDetailsList = [];
    this.additionalWorkDetailsModel = []
  }
  mapAdditionalWorkDetails() {
    this.additionalWorkDetails.appointmentAdditionalDemandList.forEach(element => {
      this.additionalWorkJobDetailsViewModelList = []
      let jobList = this.additionalWorkDetails.appointmentAdditionalJobList.filter(x => x.demandNo === element.demandNo)
      let jobDeatilsList = this.additionalWorkDetails.appointmentAdditionalJobDetailList.filter(x => x.demandNo === element.demandNo)

      jobList.forEach(job => {
        if (element.demandNo === job.demandNo) {
          const additionalWorkJobDetailsViewModel = {
            canBeDoneNow: false,
            description: '',
            fixedPrice: 0,
            isAdminApproved: 0,
            isCDSSApproved: 0,
            isCustomerApporved: 0,
            isMechanicApproved: 0,
            jobNo: 0,
            partInStock: 0,
            partNumber: '',
            price: 0,
            time: 0,
            quantity: 0,
            isEnable: false,
            id: 0,
            isJob: false
          }
          additionalWorkJobDetailsViewModel.canBeDoneNow = job.canBeDoneNow;
          additionalWorkJobDetailsViewModel.description = job.description;
          additionalWorkJobDetailsViewModel.fixedPrice = job.fixedPrice;
          additionalWorkJobDetailsViewModel.isAdminApproved = job.isAdminApproved;
          additionalWorkJobDetailsViewModel.isCDSSApproved = job.isCDSSApproved;
          additionalWorkJobDetailsViewModel.isCustomerApporved = job.isCustomerApporved;
          additionalWorkJobDetailsViewModel.isMechanicApproved = job.isMechanicApproved;
          additionalWorkJobDetailsViewModel.jobNo = job.jobId;
          additionalWorkJobDetailsViewModel.price = job.price;
          additionalWorkJobDetailsViewModel.isJob = true;
          additionalWorkJobDetailsViewModel.id = job.id;
          additionalWorkJobDetailsViewModel.isEnable = (job.isAdminApproved === 1 || job.isCDSSApproved === 1 || job.isCustomerApporved === 1 || job.isMechanicApproved === 1 || job.canBeDoneNow === true) ? false : true
          this.additionalWorkJobDetailsViewModelList.push(additionalWorkJobDetailsViewModel);
        }
      })
      jobDeatilsList.forEach(jodDetails => {
        if (element.demandNo === jodDetails.demandNo) {
          const additionalWorkJobDetailsViewModel = {
            canBeDoneNow: false,
            description: '',
            fixedPrice: 0,
            isAdminApproved: 0,
            isCDSSApproved: 0,
            isCustomerApporved: 0,
            isMechanicApproved: 0,
            jobNo: 0,
            partInStock: 0,
            partNumber: '',
            price: 0,
            time: 0,
            quantity: 0,
            isEnable: false,
            id: 0,
            isJob: false
          }
          additionalWorkJobDetailsViewModel.canBeDoneNow = jodDetails.canBeDoneNow;
          additionalWorkJobDetailsViewModel.description = jodDetails.description;
          additionalWorkJobDetailsViewModel.fixedPrice = jodDetails.fixedPrice;
          additionalWorkJobDetailsViewModel.isAdminApproved = jodDetails.isAdminApproved;
          additionalWorkJobDetailsViewModel.isCDSSApproved = jodDetails.isCDSSApproved;
          additionalWorkJobDetailsViewModel.isCustomerApporved = jodDetails.isCustomerApporved;
          additionalWorkJobDetailsViewModel.isMechanicApproved = jodDetails.isMechanicApproved;
          additionalWorkJobDetailsViewModel.jobNo = jodDetails.jobId;
          additionalWorkJobDetailsViewModel.price = jodDetails.salesPriceAmountVAT;
          additionalWorkJobDetailsViewModel.partNumber = jodDetails.salesPart;
          additionalWorkJobDetailsViewModel.time = jodDetails.plannedQuantity;
          additionalWorkJobDetailsViewModel.quantity = jodDetails.quantity;
          additionalWorkJobDetailsViewModel.isJob = false;
          additionalWorkJobDetailsViewModel.id = jodDetails.id;
          additionalWorkJobDetailsViewModel.isEnable = (jodDetails.isAdminApproved === 1 || jodDetails.isCDSSApproved === 1 || jodDetails.isCustomerApporved === 1 || jodDetails.isMechanicApproved === 1 || jodDetails.canBeDoneNow === true) ? false : true
          this.additionalWorkJobDetailsViewModelList.push(additionalWorkJobDetailsViewModel);
        }
      })
      const additionalWorkDetailsViewModel = {
        canBeDoneNow: false,
        description: '',
        fixedPrice: 0,
        isAdminApproved: 0,
        isCDSSApproved: 0,
        isCustomerApporved: 0,
        isMechanicApproved: 0,
        jobNo: 0,
        partInStock: 0,
        partNumber: '',
        price: 0,
        time: 0,
        demand: 0,
        isEnable: false,
        id: 0,
        jobDetails: [],
        isDemandEnable:false
      }
      additionalWorkDetailsViewModel.demand = element.demandNo;
      additionalWorkDetailsViewModel.id = element.id;
      additionalWorkDetailsViewModel.description = element.shortDescription;
      additionalWorkDetailsViewModel.price = element.sumPerServiceInclTax;
      additionalWorkDetailsViewModel.isAdminApproved = element.isAdminApproved;
      additionalWorkDetailsViewModel.isCDSSApproved = element.isCDSSApproved;
      additionalWorkDetailsViewModel.isCustomerApporved = element.isCustomerApporved;
      additionalWorkDetailsViewModel.isMechanicApproved = element.isMechanicApproved;
      additionalWorkDetailsViewModel.canBeDoneNow = element.canBeDoneNow;
      additionalWorkDetailsViewModel.fixedPrice = element.fixedPrice;
      additionalWorkDetailsViewModel.jobDetails = this.additionalWorkJobDetailsViewModelList;
      additionalWorkDetailsViewModel.isDemandEnable =  (element.isAdminApproved === 1 || element.isCDSSApproved === 1 || element.isCustomerApporved === 1 || element.isMechanicApproved === 1 ||
        element.isAdminApproved === -1 || element.isCDSSApproved === -1 || element.isCustomerApporved === -1 || element.isMechanicApproved === -1 || element.canBeDoneNow === true) ? false : true
      additionalWorkDetailsViewModel.isEnable = (element.isAdminApproved === 1 || element.isCDSSApproved === 1 || element.isCustomerApporved === 1 || element.isMechanicApproved === 1 || element.canBeDoneNow === true) ? false : true
      this.additionalWorkDetailsModel.push(additionalWorkDetailsViewModel)
    });
  }
  emitCanBeDoneNowData(event: any, data) {
    this.isCanBeDoneNow = false
    data.jobDetails.forEach(element => {
      element.canBeDoneNow = event
    });
    if (event === true) {
      this.isCanBeDoneNow = true;
    }
  }
  emitCustomerApprovedData(event: any, data) {
    data.jobDetails.forEach(element => {
      element.isCustomerApporved = event
    });
  }
  emitAdminApprovedData(event: any, data) {
    if(data.isCDSSApproved || data.isCustomerApporved || data.isMechanicApproved){
        data.jobDetails.forEach(element => {
        element.isAdminApproved = event
        element.isUpdated = event
        element.isApprove = event
      });
    }
    else{
      this.isApprove = event;
      this.isCanBeDoneNow = event
      data.canBeDoneNow = event
      data.isUpdated = event
      data.jobDetails.forEach(element => {
        element.isAdminApproved = event
        element.canBeDoneNow = event
        element.isUpdated = event
        element.isApprove = event
      });
    }
  }
  emitCDSSApprovedData(event: any, data) {
    if(data.isAdminApproved || data.isCustomerApporved || data.isMechanicApproved){
      data.jobDetails.forEach(element => {
        element.isCDSSApproved = event    
        element.isUpdated = event
      });
    }
    else{
      this.isApprove = event;
      this.isCanBeDoneNow = event
    data.canBeDoneNow = event
    data.isUpdated = event
    data.jobDetails.forEach(element => {
      element.isCDSSApproved = event
      element.canBeDoneNow = event
      element.isUpdated = event
      
    });
    }
  }
  CanBeDoneNowData(event: any, data, isJobs) {
    this.isCanBeDoneNow = false
    if (event === false) {
      data.canBeDoneNow = event;
    }
    if (event === true) {
      data.canBeDoneNow = event;
    }
    if (isJobs) {
      data.jobDetails.forEach(element => {
        element.canBeDoneNow = event;
      })
    }
    if (isJobs === false && event === false && data.jobDetails.length === 2) {
      data.jobDetails.forEach(element => {
        if (element.isJob === true) {
          element.canBeDoneNow = event;
        }
      })
      this.isCanBeDoneNow = false
    }
    if (isJobs === false && event !== false) {
      data.jobDetails.forEach(element => {
        if (element.isJob === true) {
          element.canBeDoneNow = event;
        }
      })
    }
    if (event === false && data.jobDetails.length === 1) {
      data.jobDetails.forEach(element => {
        if (element.isJob === true) {
          element.canBeDoneNow = event;
        }
      })
      this.isCanBeDoneNow = false
    }
    if (event === true || event === false) {
      let arr = data.jobDetails.filter(x => x.isJob === false && x.canBeDoneNow === true)
      if (arr && arr.length > 0) {
        this.isCanBeDoneNow = true;
      }
    }
  }

  AdminNowData(event: any, data, isJobs) {
    if (!(data.isCDSSApproved || data.isCustomerApporved || data.isMechanicApproved)) {
      this.isApprove = false;
      this.isCanBeDoneNow = event
    }
    if (event === false) {
      data.isAdminApproved = event;
    }
    if (event === false && !(data.isCDSSApproved || data.isCustomerApporved || data.isMechanicApproved)) {
      data.isUpdated = event
      data.canBeDoneNow = event;
    }
    if (event === true) {
      data.isAdminApproved = event;
      data.canBeDoneNow = event;
      data.isUpdated = event
    }
    if (isJobs) {
      data.jobDetails.forEach(element => {
        element.isAdminApproved = event;
        if(!(data.isCDSSApproved || data.isCustomerApporved || data.isMechanicApproved)){
          element.isUpdated = event
          element.canBeDoneNow = event;
        }
      })
    }
    if (isJobs === false && event === false && data.jobDetails.length === 2) {
      data.jobDetails.forEach(element => {
        if (element.isJob === true) {
          element.isAdminApproved = event;
        }
        if (element.isJob === true && !(data.isCDSSApproved || data.isCustomerApporved || data.isMechanicApproved)) {
          element.isUpdated = event
          element.canBeDoneNow = event;
        }
      })
    }
    if (isJobs === false && event !== false) {
      data.jobDetails.forEach(element => {
        if (element.isJob === true) {
          element.isAdminApproved = event;
          element.canBeDoneNow = event;
          element.isUpdated = event
        }
      })
    }
    if (event === false && data.jobDetails.length === 1) {
      data.jobDetails.forEach(element => {
        if (element.isJob === true) {
          element.isAdminApproved = event;
          element.canBeDoneNow = event;
          element.isUpdated = event
        }
      })
    }
    if (event === true || event === false) {
      data.jobDetails.map(x => {
        if (x.isJob === false && x.isAdminApproved === true) {
          x.canBeDoneNow = true
        } else if (x.isJob === false && x.isAdminApproved === false && !(data.isCDSSApproved || data.isCustomerApporved || data.isMechanicApproved)) {
          x.canBeDoneNow = false
        }
      })
      let arr = data.jobDetails.filter(x => x.isJob === false && x.isAdminApproved === true)
      if (arr && arr.length > 0) {
        this.isApprove = true;
        this.isCanBeDoneNow = event;
      }
    }
  }
  CDSSNowData(event: any, data, isJobs) {
    if(!(data.isAdminApproved || data.isCustomerApporved || data.isMechanicApproved)){
      this.isApprove = false;
      this.isCanBeDoneNow = event
    }
    if (event === false) {
      data.isCDSSApproved = event;
    }
    if (event === false && !(data.isAdminApproved || data.isCustomerApporved || data.isMechanicApproved)) {
      data.isUpdated = event;
      data.canBeDoneNow = event;
    }
    if (event === true) {
      data.isCDSSApproved = event;
      data.canBeDoneNow = event;
      data.isUpdated = event;
    }
    if (isJobs) {
      data.jobDetails.forEach(element => {
        element.isCDSSApproved = event;
        if (element.isJob === true && !(data.isAdminApproved || data.isCustomerApporved || data.isMechanicApproved)) {
          element.isUpdated = event
          element.canBeDoneNow = event;
        }
      })
    }
    if (isJobs === false && event === false && data.jobDetails.length === 2) {
      data.jobDetails.forEach(element => {
        if (element.isJob === true) {
          element.isCDSSApproved = event;
        }
        if(!(data.isAdminApproved || data.isCustomerApporved || data.isMechanicApproved)){
          element.isUpdated = event
          element.canBeDoneNow = event;
        }
      })
    }
    if (isJobs === false && event !== false) {
      data.jobDetails.forEach(element => {
        if (element.isJob === true) {
          element.isCDSSApproved = event;
          element.canBeDoneNow = event;
          element.isUpdated = event
        }
      })
    }
    if (event === false && data.jobDetails.length === 1) {
      data.jobDetails.forEach(element => {
        if (element.isJob === true) {
          element.isCDSSApproved = event;
          element.canBeDoneNow = event;
          element.isUpdated = event
        }
      })
    }
    if (event === true || event === false) {
      data.jobDetails.map(x =>
        {
          if(x.isJob === false && x.isCDSSApproved === true){
            x.canBeDoneNow = true
          }else if(x.isJob === false && x.isCDSSApproved === false && !(data.isAdminApproved || data.isCustomerApporved || data.isMechanicApproved)){
            x.canBeDoneNow = false
          }
        })
      let arr = data.jobDetails.filter(x => x.isJob === false && x.isCDSSApproved === true)
      if (arr && arr.length > 0) {
        this.isApprove = true;
        this.isCanBeDoneNow = event;
      }
    }
  }


  ApproveOrReject(isRejected: any,isForCustomerApproval:any,isToNotify: any) {
    this.IsApproval = !isRejected;
    this.isApprove = false
    this.isCanBeDoneNow = false
    let counter = 0;
    let isCounter:boolean = false;
    this.additionalWorkDetailsModel.forEach((element) => {
      this.additionalWorkDetails.appointmentAdditionalDemandList.forEach((x) => {
        if (x.id === element.id) {
          x.isAdminApproved = (isRejected === true && element.isAdminApproved) ? -1 : +element.isAdminApproved
          x.isCDSSApproved = (isRejected === true && element.isCDSSApproved) ? -1 : +element.isCDSSApproved
            x.isCustomerApporved = element.isCustomerApporved
            x.isMechanicApproved = element.isMechanicApproved
            x.canBeDoneNow = element.canBeDoneNow
            if((x.isAdminApproved === 1|| x.isCDSSApproved === 1) && element.isUpdated === true){
              x.index = counter + 1
              isCounter = true
            }
            else{
              x.index = 0
              isCounter = false
            }

        }
      })

      element.jobDetails.forEach(Jobelement => {
        this.additionalWorkDetails.appointmentAdditionalJobList.forEach((x) => {
          if (x.id === Jobelement.id && Jobelement.isJob === true) {
            x.isAdminApproved = (isRejected === true && Jobelement.isAdminApproved) ? -1 : +Jobelement.isAdminApproved
              x.isCDSSApproved = (isRejected === true && Jobelement.isCDSSApproved) ? -1 : +Jobelement.isCDSSApproved
              x.isCustomerApporved = Jobelement.isCustomerApporved
              x.isMechanicApproved = Jobelement.isMechanicApproved
              x.canBeDoneNow = Jobelement.canBeDoneNow
              if((x.isAdminApproved === 1 || x.isCDSSApproved === 1) && element.isUpdated === true){
                x.index = counter + 1
                isCounter = true
              }
              else{
                x.index = 0
                isCounter = false
              }
          }
        })
        this.additionalWorkDetails.appointmentAdditionalJobDetailList.forEach((x) => {
          if (x.id === Jobelement.id && Jobelement.isJob === false) {
            x.isAdminApproved = isRejected === true ? -1 : +Jobelement.isAdminApproved
              x.isCDSSApproved = isRejected === true ? -1 : +Jobelement.isCDSSApproved
              x.isCustomerApporved = Jobelement.isCustomerApporved
              x.isMechanicApproved = Jobelement.isMechanicApproved
              x.canBeDoneNow = Jobelement.canBeDoneNow
              if((x.isAdminApproved === 1|| x.isCDSSApproved === 1) && element.isUpdated === true){
                x.index = counter + 1
                isCounter = true
              }
              else{
                x.index = 0
                isCounter = false
              }
          }
        })
      });

    if(isCounter === true){
      counter = counter + 1
    }
    })
    if(isForCustomerApproval){
      if(this.customerList.length == 0){
        this.appointmentService.getCustomerWithMobile(this.editAppointmentService.appointmentDetails.appointmentId).then((response) => {
          this.spinner.hide();
          if(response.length > 0){
            this.customerList = response;
            this.customerList.forEach(element => {
              if(element.isContactCustomer){
                let msg = this.translate.instant("lblContactName");
                element.customerNo = msg;
              }
            });
            this.OpenCustomerListModal()
          }
        }, _error => {
          this.spinner.hide()
        });
      }
      else{
        this.OpenCustomerListModal();
      }
    }
    else{
      this.UpdateAdditionalWorkDetails(isForCustomerApproval,isRejected,isToNotify)
    }
  }

  async OpenUpdateDemandConfirmation(data: any) {
    let counter = 0;
    this.model.open(this.updateDemandConfirmContent, { size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((_result) => {
      
    }, async (isToNotify) => {
      if (isToNotify !== true && isToNotify !== false) {
        return;
      }
      data.isCDSSApproved = 0;
      data.isCustomerApporved = 0;
      data.isMechanicApproved = 0;
      data.isAdminApproved = 1;
      data.isUpdated = true;
      if(isToNotify){
        await this.OpenSendNotificationModel(false,true);
      }
      else{
        await this.ApproveOrReject(false,false,false);
      }
    });
  }

  OpenCustomerListModal() {
    this.model.open(this.customerListContent, { size: 'md', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, (reason) => {
      if(!reason){
        this.customerRadio = -1;
        this.customerMobileNumber = null;
      }
    });
  }

  SendSMSCustomer(customer:any,index:any){
    this.customerRadio = index;
    this.customerMobileNumber = customer.customerMobileNumber
    this.customerMobileCode = customer.customerMobileCode
  }

  async UpdateAdditionalWorkDetails(isForCustomerApproval,isRejected,_isToNotify) {
    let model = {
      AppointmentAdditionalJobDetailList: this.additionalWorkDetails.appointmentAdditionalJobDetailList,
      AppointmentAdditionalJobList: this.additionalWorkDetails.appointmentAdditionalJobList,
      AppointmentAdditionalDemandList: this.additionalWorkDetails.appointmentAdditionalDemandList,
      IsApproved: this.IsApproval,
      AppointmentId: this.editAppointmentService.appointmentDetails.id,
      AppointmentGuid: this.editAppointmentService.appointmentDetails.appointmentGuid,
      IsForCustomerApproval: isForCustomerApproval,
      LanguageCode: this.cookieservice.get('userSelectedLanguage'),
      WorkOrderNo: this.editAppointmentService.appointmentDetails.workOrderNo,
      CustomerMobileNumber:this.customerMobileNumber,
      CustomerMobileCode:this.customerMobileCode
    }
    this.spinner.show();
    await this.appointmentService.UpdateAdditionalWorkDetails(model).then((res) => {
      let msg = '';
      if (res) {
        this.onRefresh()
        this.GetAdditionalWorkDetails();
        if(isForCustomerApproval){
          msg = this.translate.instant("lblCustomersApproval")
          this.toastr.success(msg);
        }
        else{
          if(isRejected===true || isRejected==='true')
          {
            msg = this.translate.instant("lblRejected")
          }
          else{
            msg = this.translate.instant("lblApproved")
          }
          this.toastr.success(msg);
        }
        this.spinner.hide();
      }
    })

  }
  notifyOrReject(isToNotify, isRejected) {
    if (isToNotify && isRejected) {
      return 2;
    } else if (isToNotify && !isRejected) {
      return 1;
    } else {
      return 0;
    }
  }

  OpenSendNotificationModel(isRejected: any,isToNotify: any): void {
    let isForApprovalORRejection = this.notifyOrReject(isToNotify, isRejected)
    const modalref = this.model.open(SendNotificationComponent, { size: 'lg', windowClass: 'pop-wid1200' });
    modalref.componentInstance.appointmentId = this.editAppointmentService.appointmentDetails.id;
    modalref.componentInstance.dealerId = this.editAppointmentService.appointmentDetails.dealerId;
    modalref.componentInstance.isForApprovalORRejection = isForApprovalORRejection;
    modalref.result.then((_response) => {
      if(_response.success){
        this.ApproveOrReject(isRejected,false,isToNotify)
      }
    });
  }
}
